const bedrockMatchFields = [
    { label: 'Bedrock Decision', key: 'ABP_Bedrock_Decision' },
    { label: 'Suggested UPRN', key: 'ABP_Bedrock_Suggested_UPRN' },
    { label: 'Organisation', key: 'ABP_Bedrock_Organisation' },
    { label: 'Sub Building', key: 'SUB_BUILDING' },
    { label: 'Building Name', key: 'BUILDING_NAME' },
    { label: 'Building Number', key: 'BUILDING_NUMBER' },
    { label: 'Street Name', key: 'STREET_NAME' },
    { label: 'Postcode', key: 'POSTCODE' },
]

export default function BedrockMatchTable({ data, translations }) {
    return (
        <table className="table borders squish smaller-text left" style={{ width: '100%' }}>
            <thead>
                <tr>
                    <th colSpan={2}>{translations['bedrock_match'] || 'Bedrock Match'}</th>
                </tr>
            </thead>
            <tbody>
                {bedrockMatchFields.map(({ label, key }) => (
                    <tr key={label}>
                        <td style={{ width: '20em' }}>{translations[label.toLowerCase().replace(/ /g, '_')] || label}</td>
                        <td>{data?.[key]}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}
